import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '@clerk/clerk-react';

import { ROUTES } from '@/routes';
import { FullScreenSpinner } from '@/components/FullScreenSpinner';

interface PublicRouteProps {
  children?: React.ReactNode;
  redirectTo?: string;
}

export const PublicRoute: React.FC<PublicRouteProps> = ({
  children,
  redirectTo = ROUTES.SESSIONS,
}) => {
  const { isLoaded, isSignedIn } = useAuth();

  if (!isLoaded) {
    return <FullScreenSpinner message="Loading..." />;
  }

  if (isSignedIn) {
    return <Navigate to={redirectTo} replace />;
  }

  return children ? <>{children}</> : <Outlet />;
};

export default PublicRoute;
